// import echarts from "echarts";
import * as echarts from "echarts";
export function loadChart(myChart, content) {
  let yAxisData1 = content.map(v => v.temp); //温度
  let yAxisData2 = content.map(v => v.humi); //湿度
  let yAxisData3 = content.map(v => v.direction); //风向
  let yAxisData4 = content.map(v => v.speed); //风速
  let yAxisData5 = content.map(v => v.airp); //气压
  let xAxisData = content.map(v => v.date);
  myChart.setOption(
    {
      color: "#0090FF",
      legend: {
        data: ["温度", "湿度", "风向", "风速", "气压"],
        right: 10,
        textStyle: {
          color: "#fff"
        },
        selectedMode: "single"
      },
      tooltip: {
        trigger: "axis"
      },
      grid: {
        top: 35,
        right: 25,
        left: 25,
        bottom: 20,
        containLabel: true
      },
      xAxis: [
        {
          type: "category",
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          },
          axisLabel: {
            color: "#fff"
          },
          data: xAxisData
        }
      ],
      yAxis: [
        {
          type: "value",
          name: "°C",
          axisLabel: {
            textStyle: {
              color: "#fff"
            }
          },
          nameTextStyle: {
            color: "#fff"
          },
          splitLine: {
            lineStyle: {
              color: "rgba(0, 144, 255,0.3)"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          },
          axisTick: {
            show: false
          }
        }
      ],
      series: [
        {
          name: "温度",
          type: "line",
          smooth: true,
          showSymbol: false,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "rgba(0, 144, 255, 0.3)"
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 144, 255,0.1)"
                  }
                ],
                false
              ),
              shadowColor: "rgba(0, 144, 255,0.1)",
              shadowBlur: 10
            }
          },
          data: yAxisData1
        },
        {
          name: "湿度",
          type: "line",
          smooth: true,
          showSymbol: false,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "rgba(0, 144, 255, 0.3)"
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 144, 255,0.1)"
                  }
                ],
                false
              ),
              shadowColor: "rgba(0, 144, 255,0.1)",
              shadowBlur: 10
            }
          },
          data: yAxisData2
        },
        {
          name: "风向",
          type: "line",
          smooth: true,
          showSymbol: false,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "rgba(0, 144, 255, 0.3)"
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 144, 255,0.1)"
                  }
                ],
                false
              ),
              shadowColor: "rgba(0, 144, 255,0.1)",
              shadowBlur: 10
            }
          },
          data: yAxisData3
        },
        {
          name: "风速",
          type: "line",
          smooth: true,
          showSymbol: false,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "rgba(0, 144, 255, 0.3)"
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 144, 255,0.1)"
                  }
                ],
                false
              ),
              shadowColor: "rgba(0, 144, 255,0.1)",
              shadowBlur: 10
            }
          },
          data: yAxisData4
        },
        {
          name: "气压",
          type: "line",
          smooth: true,
          showSymbol: false,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "rgba(0, 144, 255, 0.3)"
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 144, 255,0.1)"
                  }
                ],
                false
              ),
              shadowColor: "rgba(0, 144, 255,0.1)",
              shadowBlur: 10
            }
          },
          data: yAxisData5
        }
      ]
    },
    true
  );
  myChart.on("legendselectchanged", function(params) {
    let option = this.getOption();
    if (params.name === "温度") {
      option.yAxis[0].name = "°C";
    } else if (params.name === "湿度") {
      option.yAxis[0].name = " %";
    } else if (params.name === "风向") {
      option.yAxis[0].name = " °";
    } else if (params.name === "风速") {
      option.yAxis[0].name = "m/s";
    } else if (params.name === "气压") {
      option.yAxis[0].name = "hpa";
    }
    myChart.setOption(option);
  });
}
